import { Pipe, PipeTransform } from '@angular/core';
import { ICatalog } from 'models/catalog.model';

@Pipe({
  name: 'totalAmount'
})

export class TotalAmountPipe implements PipeTransform {

  transform(value: ICatalog[]) {
    return value.map(item => item.price).reduce((total, next) => {
      total += next;
      return total;
    }, 0);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/total-amount.pipe.ts